module.exports = __webpack_public_path__ + "akne_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_1_before.jpg
// module id = 916
// module chunks = 0